import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

import Footer from "./layout/Footer";
import Header from "./layout/Header";
import Sidebar from "./layout/Sidebar";

import Home from "./screens/Home";
import Raffles from "./screens/Raffles";
import Raffle from "./screens/Raffle";
import AddRaffle from "./screens/AddRaffle";
import Login from "./screens/Login";
import Users from "./screens/Users";
import AddUser from "./screens/AddUser";
import User from "./screens/User";
import Form from "./screens/Form";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [isViewingForm, setIsViewingForm] = useState(false);

  const checkApiKey = () => {
    var apiKey = localStorage.getItem("apiSesionId");
    if (apiKey == null || apiKey == "") setIsLoggedIn(false);
    else setIsLoggedIn(true);
  };

  useEffect(() => {
    checkApiKey();
    const interval = setInterval(() => {
      checkApiKey();
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // check if url is /form

    if (window.location.pathname.includes("/form")) {
      setIsViewingForm(true);
    } else {
      setIsViewingForm(false);
    }
  }, []);

  if (isViewingForm)
    return (
      <div className="App">
        <Routes>
          <Route path="form/:token" element={<Form />} />
        </Routes>
      </div>
    );

  return (
    <div className="App">
      {isLoggedIn ? (
        <>
          <Header />
          <Sidebar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="raffles" element={<Raffles />} />
            <Route path="raffle/:raffleId" element={<Raffle />} />
            <Route path="add-raffle" element={<AddRaffle />} />
            <Route path="users" element={<Users />} />
            <Route path="add-user" element={<AddUser />} />
            <Route path="user/:accountId" element={<User />} />
          </Routes>
          <Footer />
        </>
      ) : (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="login" element={<Login />} />
        </Routes>
      )}
    </div>
  );
}

export default App;
